import { imageCoverContainer } from '@helpers/aspectRatio';
import brand from '@helpers/brand';
import fonts from '@helpers/fonts';
import { paragraphLarge } from '@helpers/typography';
import { rgba } from 'polished';
import styled from 'styled-components';
const Container = styled.div `
  position: relative;
`;
const ImageWrapper = styled.div `
  display: block;
`;
const Image = styled.img `
  display: block;
  max-width: none;
  width: 100%;
`;
const Overlay = styled.div `
  ${imageCoverContainer()}

  position: absolute;
  display: grid;
  background: ${rgba(brand.black, 0.4)};
  color: ${brand.white};
  place-content: center;
  place-items: center;
  z-index: 1;
`;
const Title = styled.h3 `
  ${paragraphLarge};

  ${fonts.brandonGrotesque.bold}
  margin: 0;
  text-transform: uppercase;
`;
const PinPreviewStyles = {
    Container,
    Image,
    ImageWrapper,
    Title,
    Overlay,
};
export default PinPreviewStyles;
